import * as React from "react";
import "./dial-descriptor.scss";

export const DialDescriptor: React.FunctionComponent = () => {
	return (
		<div className="dial">
			{/* rome-ignore lint/a11y/useAltText: <explanation> */}
			<img src={require("../../../assets/images/installer/peripherals/thermokon-wrf06.png")} className="dial__image" />
			<p className="dial__peripheral" data-qa="dial-descriptor-title">
				Temperature Dial - Thermokon WRF06
			</p>
		</div>
	);
};
